import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle } from 'gossamer-front-end';
import { WorkflowInitiation } from 'cb-model';

export const InitiateWorkflow = (): React.JSX.Element => {
  const navigate = useNavigate();
  const handleExit = () => navigate('/admin/workflow/search');

  return (
    <>
      <PageTitle title="Initiate Workflow" />
      <FormManager
        compoundUrl="/main/initiate-workflow"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: {
            type: 'create-single',
            entity: WorkflowInitiation,
          },
        }}
      >
        <Create valuesKey="main" entity={WorkflowInitiation} />
      </FormManager>
    </>
  );
};
